export enum RdConfigOsTypeEnum {
  Windows = 0,
  Linux = 1,
  macOS = 2,
  'All types' = 3
}
